import videojs from 'video.js';

const defaults = {
  imageUrl: '',
  imageClickUrl: '',
  imageTarget: '_blank',
  imagePosition: 'top-right',
  imageOpacity: 1,
  imageMargin: 10,
  width: 80,
  zIndex: 2147483647
};

const vjs = videojs;
const Component = vjs.getComponent('Component');

class LogoOverlay extends Component {
  constructor(player, options) {
    super(player, options);
    this.options_ = vjs.mergeOptions(defaults, options || {});
    this.build();
    this.applyPosition();
  }

  createEl() {
    return vjs.dom.createEl('div', { className: 'vjs-logo-overlay' });
  }

  build() {
    const { imageUrl, imageClickUrl, imageTarget, imageOpacity, zIndex, width } = this.options_;

    this.anchorEl = vjs.dom.createEl('a', {
      href: imageClickUrl || '#',
      target: imageTarget,
      rel: 'noopener noreferrer'
    });

    this.imgEl = vjs.dom.createEl('img', {
      src: imageUrl,
      style: `width:${width}px; height:auto;`
    });

    this.anchorEl.appendChild(this.imgEl);
    this.el().appendChild(this.anchorEl);

    this.el().style.position = 'absolute';
    this.el().style.opacity = imageOpacity;
    this.el().style.zIndex = zIndex;
  }

  applyPosition() {
    const { imagePosition, imageMargin } = this.options_;
    const el = this.el();

    el.style.top = '';
    el.style.right = '';
    el.style.bottom = '';
    el.style.left = '';

    switch (imagePosition) {
      case 'top-left':
        el.style.top = `${imageMargin}px`;
        el.style.left = `${imageMargin}px`;
        break;
      case 'top-right':
        el.style.top = `${imageMargin}px`;
        el.style.right = `${imageMargin}px`;
        break;
      case 'bottom-left':
        el.style.bottom = `${Number(imageMargin) + 30}px`;
        el.style.left = `${imageMargin}px`;
        break;
      case 'bottom-right':
      default:
        el.style.bottom = `${Number(imageMargin) + 30}px`;
        el.style.right = `${imageMargin}px`;
        break;
    }
  }
}

vjs.registerComponent('LogoOverlay', LogoOverlay);

function plugin(options) {
  let instance = this.getChild('LogoOverlay');
  if (!instance) {
    instance = this.addChild('LogoOverlay', options || {});
    this.el().appendChild(instance.el());
  } else {
    instance.update(options);
  }
  return instance;
}

vjs.registerPlugin('logoOverlay', plugin);

export default plugin;